import { render, staticRenderFns } from "./TeamMarquee.vue?vue&type=template&id=4e8735fa"
import script from "./TeamMarquee.vue?vue&type=script&lang=js"
export * from "./TeamMarquee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports